<template>
  <ul
    class="steps list-inline list-inline--tight align-items-start flex-nowrap"
  >
    <li
      v-for="(step, i) in steps"
      :key="step.id"
      :class="[
        'step',
        { current: step.id === activeStepId },
        { done: step.done },
        'flex-fill',
      ]"
    >
      <router-link v-slot="{ navigate }" custom :to="{ name: step.id }">
        <button
          :disabled="steps[i - 1] && !steps[i - 1].done"
          class="step__btn btn btn--bare btn--link btn--block"
          type="button"
          @click="navigate"
        >
          <div class="step__icon"></div>
          <div
            :class="[
              'step__label',
              { 'hidden-sm-down': step.id !== activeStepId },
            ]"
          >
            {{ step.label }}
          </div>
        </button>
      </router-link>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  steps: {
    type: Array,
    required: true,
  },
});

const route = useRoute();
const activeStepId = computed(() => route.name);
</script>

<style lang="scss" scoped>
.steps {
  padding-top: 4px;
  overflow: hidden;

  counter-set: steps;
}

.step {
  counter-increment: steps;

  @include media('md') {
    flex: 1 1 33.3333%;
  }
}

.step__btn {
  overflow: visible;

  position: relative;

  font-weight: 500;

  &:disabled {
    color: $alt-color-light;
    cursor: not-allowed;

    .step__icon {
      background-color: $alt-color-light;
    }
  }

  &:focus {
    outline: none;

    .step__icon {
      box-shadow: 0 0 0 2px $brand-alt-color;
    }
  }

  .current & {
    &,
    &:hover,
    &:focus {
      color: $brand-color;
    }
  }

  .step &::before {
    content: '';
    display: block;
    width: 200%;
    height: 4px;

    position: absolute;
    top: 13px;
    right: 50%;
    z-index: 1;

    background-color: $alt-color-light;
  }

  .step:first-child &::before {
    z-index: 3;
    background-color: $alt-color-lighter;
  }

  .step:not(:first-child).done &::before,
  .step:not(:first-child).current &::before {
    background-color: $brand-color;
    z-index: 2;
  }
}

.step__icon {
  width: 30px;
  height: 30px;
  padding: $spacing-unit-tiny;
  margin: 0 auto $spacing-unit-tiny;

  color: white;
  line-height: 11px;

  position: relative;
  z-index: 3;

  border: 2px solid $alt-color-lighter;
  background-color: $brand-color;
  border-radius: 50%;
  will-change: transform;

  &::before {
    content: counter(steps);
  }

  .done & {
    border-color: $brand-color;
    background-color: $brand-color;
  }

  .current & {
    border-color: $alt-color-lighter;
    box-shadow: 0 0 0 2px $brand-color;
  }
}

.step__label {
  padding-left: $spacing-unit-small;
  padding-right: $spacing-unit-small;
}
</style>
